export const SET_THEME="config/SET_THEME";

export const setTheme=(data)=>{
    return{
        type:SET_THEME,
        payload:data
    }
}